import { Redirect } from "@redotech/react-router-util/redirect";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

function redirectPair(
  path: string,
  match: RegExp,
  replaceValue: string,
): PermissionedRouteObject {
  return {
    path,
    children: [
      {
        index: true,
        element: <Redirect match={match} replaceValue={replaceValue} />,
      },
      {
        path: "*",
        element: <Redirect match={match} replaceValue={replaceValue} />,
      },
    ],
  };
}

/**
 * Permanent redirects from the old /finance/disputes URLs to the renamed
 * /payments/chargebacks structure. Regex replace preserves tails and query.
 */
export const legacyFinanceRedirectRoutes: PermissionedRouteObject[] = [
  {
    path: "finance",
    children: [
      {
        index: true,
        element: (
          <Redirect match={/finance$/} replaceValue="payments/chargebacks" />
        ),
      },
      {
        path: "disputes",
        children: [
          {
            index: true,
            element: (
              <Redirect
                match={/finance\/disputes$/}
                replaceValue="payments/chargebacks"
              />
            ),
          },
          redirectPair(
            "dashboard",
            /finance\/disputes\/dashboard/,
            "payments/chargebacks/overview",
          ),
          redirectPair(
            "chargebacks",
            /finance\/disputes\/chargebacks/,
            "payments/chargebacks/reclaim",
          ),
          redirectPair(
            "alerts",
            /finance\/disputes\/alerts/,
            "payments/chargebacks/alerts",
          ),
          redirectPair(
            "resolve",
            /finance\/disputes\/resolve/,
            "payments/chargebacks/resolve",
          ),
          redirectPair(
            "settings",
            /finance\/disputes\/settings/,
            "settings/chargebacks/reclaim",
          ),
          redirectPair(
            "integrations",
            /finance\/disputes\/integrations/,
            "settings/integrations",
          ),
          // Bare legacy dispute ids: /finance/disputes/<id> → Reclaim detail.
          {
            path: "*",
            element: (
              <Redirect
                match={/finance\/disputes/}
                replaceValue="payments/chargebacks/reclaim"
              />
            ),
          },
        ],
      },
      {
        path: "*",
        element: (
          <Redirect
            match={/finance\/.*$/}
            replaceValue="payments/chargebacks"
          />
        ),
      },
    ],
  },
];
